import SpaceSizes from '../../../theme/foundations/spacing/SpaceSizes';

export const MATCH_RESULT_SPACING = {
  xs: SpaceSizes.xs2,
  sm: SpaceSizes.sm,
};
